'use strict'

import ApiClient from './ApiClient'

export default class GroupRepository {
  /**
   * IDで指定した組織の直下の組織情報を取得します。
   * @param {object} params
   * @returns {*}
   */
  getList (params) {
    return ApiClient().get(`/groups`, { params })
  }

  /**
   * 新しいユーザー情報を作成します。
   * @param {object} params
   * @returns {*}
   */
  post (params) {
    return ApiClient().post(`/groups`, params)
  }

  /**
   * IDで指定した組織の直下の組織情報を取得します。(組織ツリー用)
   * @param {object} params
   * @returns {*}
   */
  tree (params) {
    return ApiClient().get(`/groups/tree`, { params })
  }

  /**
   * 表示順変更
   * @param {object} params
   * @returns {*}
   */
  sort (params) {
    return ApiClient().put(`/groups/sort`, params)
  }

  /**
   * 組織情報一件を取得します。
   * @param {string|int} id
   * @returns {*}
   */
  get (id) {
    return ApiClient().get(`/groups/${id}`)
  }

  /**
   * 組織情報を変更します。
   * @param {string|int} id
   * @param {object} params
   * @returns {*}
   */
  put (id, params) {
    return ApiClient().put(`/groups/${id}`, params)
  }

  /**
   * 組織情報を削除します。
   * @param {string|int} id
   * @returns {*}
   */
  delete (id) {
    return ApiClient().delete(`/groups/${id}`)
  }

  /**
   * IDで指定した組織情報を一括削除します。
   * @param {object} params
   * @returns {*}
   */
  bulkDelete (params) {
    return ApiClient().post(`/groups/delete`, params)
  }

  /**
   * 組織情報をCSVファイルにエクスポートします。
   * @param {object} formData フォームデータ
   * @returns {*}
   */
  postExport (formData) {
    return ApiClient().post(`/groups/export`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * 組織情報エクスポートファイルをダウンロードします。
   * @param {object} options
   * @returns {*}
   */
  getExport (options) {
    return ApiClient().get(`/groups/export`, options)
  }

  /**
   * 組織情報エクスポートの処理結果を取得する。
   * @returns {*}
   */
  getExportResult () {
    return ApiClient().get(`/groups/export-result`)
  }

  /**
   * 組織情報エクスポートを停止する。（キャンセルファイルを作成する。）
   * @returns {*}
   */
  cancelExport () {
    return ApiClient().post(`/groups/export-cancel`)
  }

  /**
   * 組織情報のCSVファイルをインポートします。
   * @param {object} formData フォームデータ
   * @returns {*}
   */
  import (formData) {
    return ApiClient().post(`/groups/import`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * 組織情報インポートの処理結果を取得する。
   * @returns {*}
   */
  getImportResult () {
    return ApiClient().get(`/groups/import-result`)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/GroupRepository.js